import React from 'react';

import DatabaseContainer from '../../containers/admin/DatabaseContainer';

export default function DatabasePage() {
    return (
        <DatabaseContainer />
    );
}
